export interface Country {
  countryCode: string | null; // ISO 3166-1 alpha;
  text: string;
}

export const FOREIGN = null;
export const COUNTRY_SELECT_LIST: Country[] = [
  { countryCode: 'JP', text: '日本' },
  { countryCode: FOREIGN, text: '海外' },
];

// export const COUNTRY_SELECT_LIST: Country[] = [
//   { countryCode: 'AD', text: 'Andorra' },
//   { countryCode: 'AE', text: 'United Arab Emirates' },
//   { countryCode: 'AF', text: 'Afghanistan' },
//   { countryCode: 'AG', text: 'Antigua and Barbuda' },
//   { countryCode: 'AI', text: 'Anguilla' },
//   { countryCode: 'AL', text: 'Albania' },
//   { countryCode: 'AM', text: 'Armenia' },
//   { countryCode: 'AO', text: 'Angola' },
//   { countryCode: 'AQ', text: 'Antarctica' },
//   { countryCode: 'AR', text: 'Argentina' },
//   { countryCode: 'AS', text: 'American Samoa' },
//   { countryCode: 'AT', text: 'Austria' },
//   { countryCode: 'AU', text: 'Australia' },
//   { countryCode: 'AW', text: 'Aruba' },
//   { countryCode: 'AX', text: 'Åland Islands' },
//   { countryCode: 'AZ', text: 'Azerbaijan' },
//   { countryCode: 'BA', text: 'Bosnia and Herzegovina' },
//   { countryCode: 'BB', text: 'Barbados' },
//   { countryCode: 'BD', text: 'Bangladesh' },
//   { countryCode: 'BE', text: 'Belgium' },
//   { countryCode: 'BF', text: 'Burkina Faso' },
//   { countryCode: 'BG', text: 'Bulgaria' },
//   { countryCode: 'BH', text: 'Bahrain' },
//   { countryCode: 'BI', text: 'Burundi' },
//   { countryCode: 'BJ', text: 'Benin' },
//   { countryCode: 'BL', text: 'Saint Barthélemy' },
//   { countryCode: 'BM', text: 'Bermuda' },
//   { countryCode: 'BN', text: 'Brunei Darussalam' },
//   { countryCode: 'BO', text: 'Bolivia (Plurinational State of)' },
//   { countryCode: 'BQ', text: 'Bonaire, Sint Eustatius and Saba' },
//   { countryCode: 'BR', text: 'Brazil' },
//   { countryCode: 'BS', text: 'Bahamas' },
//   { countryCode: 'BT', text: 'Bhutan' },
//   { countryCode: 'BV', text: 'Bouvet Island' },
//   { countryCode: 'BW', text: 'Botswana' },
//   { countryCode: 'BY', text: 'Belarus' },
//   { countryCode: 'BZ', text: 'Belize' },
//   { countryCode: 'CA', text: 'Canada' },
//   { countryCode: 'CC', text: 'Cocos (Keeling) Islands' },
//   { countryCode: 'CD', text: 'Congo, Democratic Republic of the' },
//   { countryCode: 'CF', text: 'Central African Republic' },
//   { countryCode: 'CG', text: 'Congo' },
//   { countryCode: 'CH', text: 'Switzerland' },
//   { countryCode: 'CI', text: "Côte d'Ivoire" },
//   { countryCode: 'CK', text: 'Cook Islands' },
//   { countryCode: 'CL', text: 'Chile' },
//   { countryCode: 'CM', text: 'Cameroon' },
//   { countryCode: 'CN', text: 'China' },
//   { countryCode: 'CO', text: 'Colombia' },
//   { countryCode: 'CR', text: 'Costa Rica' },
//   { countryCode: 'CU', text: 'Cuba' },
//   { countryCode: 'CV', text: 'Cabo Verde' },
//   { countryCode: 'CW', text: 'Curaçao' },
//   { countryCode: 'CX', text: 'Christmas Island' },
//   { countryCode: 'CY', text: 'Cyprus' },
//   { countryCode: 'CZ', text: 'Czechia' },
//   { countryCode: 'DE', text: 'Germany' },
//   { countryCode: 'DJ', text: 'Djibouti' },
//   { countryCode: 'DK', text: 'Denmark' },
//   { countryCode: 'DM', text: 'Dominica' },
//   { countryCode: 'DO', text: 'Dominican Republic' },
//   { countryCode: 'DZ', text: 'Algeria' },
//   { countryCode: 'EC', text: 'Ecuador' },
//   { countryCode: 'EE', text: 'Estonia' },
//   { countryCode: 'EG', text: 'Egypt' },
//   { countryCode: 'EH', text: 'Western Sahara' },
//   { countryCode: 'ER', text: 'Eritrea' },
//   { countryCode: 'ES', text: 'Spain' },
//   { countryCode: 'ET', text: 'Ethiopia' },
//   { countryCode: 'FI', text: 'Finland' },
//   { countryCode: 'FJ', text: 'Fiji' },
//   { countryCode: 'FK', text: 'Falkland Islands (Malvinas)' },
//   { countryCode: 'FM', text: 'Micronesia (Federated States of)' },
//   { countryCode: 'FO', text: 'Faroe Islands' },
//   { countryCode: 'FR', text: 'France' },
//   { countryCode: 'GA', text: 'Gabon' },
//   { countryCode: 'GB', text: 'United Kingdom of Great Britain and Northern Ireland' },
//   { countryCode: 'GD', text: 'Grenada' },
//   { countryCode: 'GE', text: 'Georgia' },
//   { countryCode: 'GF', text: 'French Guiana' },
//   { countryCode: 'GG', text: 'Guernsey' },
//   { countryCode: 'GH', text: 'Ghana' },
//   { countryCode: 'GI', text: 'Gibraltar' },
//   { countryCode: 'GL', text: 'Greenland' },
//   { countryCode: 'GM', text: 'Gambia' },
//   { countryCode: 'GN', text: 'Guinea' },
//   { countryCode: 'GP', text: 'Guadeloupe' },
//   { countryCode: 'GQ', text: 'Equatorial Guinea' },
//   { countryCode: 'GR', text: 'Greece' },
//   { countryCode: 'GS', text: 'South Georgia and the South Sandwich Islands' },
//   { countryCode: 'GT', text: 'Guatemala' },
//   { countryCode: 'GU', text: 'Guam' },
//   { countryCode: 'GW', text: 'Guinea-Bissau' },
//   { countryCode: 'GY', text: 'Guyana' },
//   { countryCode: 'HK', text: 'Hong Kong' },
//   { countryCode: 'HM', text: 'Heard Island and McDonald Islands' },
//   { countryCode: 'HN', text: 'Honduras' },
//   { countryCode: 'HR', text: 'Croatia' },
//   { countryCode: 'HT', text: 'Haiti' },
//   { countryCode: 'HU', text: 'Hungary' },
//   { countryCode: 'ID', text: 'Indonesia' },
//   { countryCode: 'IE', text: 'Ireland' },
//   { countryCode: 'IL', text: 'Israel' },
//   { countryCode: 'IM', text: 'Isle of Man' },
//   { countryCode: 'IN', text: 'India' },
//   { countryCode: 'IO', text: 'British Indian Ocean Territory' },
//   { countryCode: 'IQ', text: 'Iraq' },
//   { countryCode: 'IR', text: 'Iran (Islamic Republic of)' },
//   { countryCode: 'IS', text: 'Iceland' },
//   { countryCode: 'IT', text: 'Italy' },
//   { countryCode: 'JE', text: 'Jersey' },
//   { countryCode: 'JM', text: 'Jamaica' },
//   { countryCode: 'JO', text: 'Jordan' },
//   { countryCode: 'JP', text: 'Japan' },
//   { countryCode: 'KE', text: 'Kenya' },
//   { countryCode: 'KG', text: 'Kyrgyzstan' },
//   { countryCode: 'KH', text: 'Cambodia' },
//   { countryCode: 'KI', text: 'Kiribati' },
//   { countryCode: 'KM', text: 'Comoros' },
//   { countryCode: 'KN', text: 'Saint Kitts and Nevis' },
//   { countryCode: 'KP', text: "Korea, Democratic People's Republic of" },
//   { countryCode: 'KR', text: 'Korea, Republic of' },
//   { countryCode: 'KW', text: 'Kuwait' },
//   { countryCode: 'KY', text: 'Cayman Islands' },
//   { countryCode: 'KZ', text: 'Kazakhstan' },
//   { countryCode: 'LA', text: "Lao People's Democratic Republic" },
//   { countryCode: 'LB', text: 'Lebanon' },
//   { countryCode: 'LC', text: 'Saint Lucia' },
//   { countryCode: 'LI', text: 'Liechtenstein' },
//   { countryCode: 'LK', text: 'Sri Lanka' },
//   { countryCode: 'LR', text: 'Liberia' },
//   { countryCode: 'LS', text: 'Lesotho' },
//   { countryCode: 'LT', text: 'Lithuania' },
//   { countryCode: 'LU', text: 'Luxembourg' },
//   { countryCode: 'LV', text: 'Latvia' },
//   { countryCode: 'LY', text: 'Libya' },
//   { countryCode: 'MA', text: 'Morocco' },
//   { countryCode: 'MC', text: 'Monaco' },
//   { countryCode: 'MD', text: 'Moldova, Republic of' },
//   { countryCode: 'ME', text: 'Montenegro' },
//   { countryCode: 'MF', text: 'Saint Martin (French part)' },
//   { countryCode: 'MG', text: 'Madagascar' },
//   { countryCode: 'MH', text: 'Marshall Islands' },
//   { countryCode: 'MK', text: 'North Macedonia' },
//   { countryCode: 'ML', text: 'Mali' },
//   { countryCode: 'MM', text: 'Myanmar' },
//   { countryCode: 'MN', text: 'Mongolia' },
//   { countryCode: 'MO', text: 'Macau' },
//   { countryCode: 'MP', text: 'Northern Mariana Islands' },
//   { countryCode: 'MQ', text: 'Martinique' },
//   { countryCode: 'MR', text: 'Mauritania' },
//   { countryCode: 'MS', text: 'Montserrat' },
//   { countryCode: 'MT', text: 'Malta' },
//   { countryCode: 'MU', text: 'Mauritius' },
//   { countryCode: 'MV', text: 'Maldives' },
//   { countryCode: 'MW', text: 'Malawi' },
//   { countryCode: 'MX', text: 'Mexico' },
//   { countryCode: 'MY', text: 'Malaysia' },
//   { countryCode: 'MZ', text: 'Mozambique' },
//   { countryCode: 'NA', text: 'Namibia' },
//   { countryCode: 'NC', text: 'New Caledonia' },
//   { countryCode: 'NE', text: 'Niger' },
//   { countryCode: 'NF', text: 'Norfolk Island' },
//   { countryCode: 'NG', text: 'Nigeria' },
//   { countryCode: 'NI', text: 'Nicaragua' },
//   { countryCode: 'NL', text: 'Netherlands' },
//   { countryCode: 'NO', text: 'Norway' },
//   { countryCode: 'NP', text: 'Nepal' },
//   { countryCode: 'NR', text: 'Nauru' },
//   { countryCode: 'NU', text: 'Niue' },
//   { countryCode: 'NZ', text: 'New Zealand' },
//   { countryCode: 'OM', text: 'Oman' },
//   { countryCode: 'PA', text: 'Panama' },
//   { countryCode: 'PE', text: 'Peru' },
//   { countryCode: 'PF', text: 'French Polynesia' },
//   { countryCode: 'PG', text: 'Papua New Guinea' },
//   { countryCode: 'PH', text: 'Philippines' },
//   { countryCode: 'PK', text: 'Pakistan' },
//   { countryCode: 'PL', text: 'Poland' },
//   { countryCode: 'PM', text: 'Saint Pierre and Miquelon' },
//   { countryCode: 'PN', text: 'Pitcairn' },
//   { countryCode: 'PR', text: 'Puerto Rico' },
//   { countryCode: 'PS', text: 'Palestine, State of' },
//   { countryCode: 'PT', text: 'Portugal' },
//   { countryCode: 'PW', text: 'Palau' },
//   { countryCode: 'PY', text: 'Paraguay' },
//   { countryCode: 'QA', text: 'Qatar' },
//   { countryCode: 'RE', text: 'Réunion' },
//   { countryCode: 'RO', text: 'Romania' },
//   { countryCode: 'RS', text: 'Serbia' },
//   { countryCode: 'RU', text: 'Russian Federation' },
//   { countryCode: 'RW', text: 'Rwanda' },
//   { countryCode: 'SA', text: 'Saudi Arabia' },
//   { countryCode: 'SB', text: 'Solomon Islands' },
//   { countryCode: 'SC', text: 'Seychelles' },
//   { countryCode: 'SD', text: 'Sudan' },
//   { countryCode: 'SE', text: 'Sweden' },
//   { countryCode: 'SG', text: 'Singapore' },
//   { countryCode: 'SH', text: 'Saint Helena, Ascension and Tristan da Cunha' },
//   { countryCode: 'SI', text: 'Slovenia' },
//   { countryCode: 'SJ', text: 'Svalbard and Jan Mayen' },
//   { countryCode: 'SK', text: 'Slovakia' },
//   { countryCode: 'SL', text: 'Sierra Leone' },
//   { countryCode: 'SM', text: 'San Marino' },
//   { countryCode: 'SN', text: 'Senegal' },
//   { countryCode: 'SO', text: 'Somalia' },
//   { countryCode: 'SR', text: 'Suritext' },
//   { countryCode: 'SS', text: 'South Sudan' },
//   { countryCode: 'ST', text: 'Sao Tome and Principe' },
//   { countryCode: 'SV', text: 'El Salvador' },
//   { countryCode: 'SX', text: 'Sint Maarten (Dutch part)' },
//   { countryCode: 'SY', text: 'Syrian Arab Republic' },
//   { countryCode: 'SZ', text: 'Eswatini' },
//   { countryCode: 'TC', text: 'Turks and Caicos Islands' },
//   { countryCode: 'TD', text: 'Chad' },
//   { countryCode: 'TF', text: 'French Southern Territories' },
//   { countryCode: 'TG', text: 'Togo' },
//   { countryCode: 'TH', text: 'Thailand' },
//   { countryCode: 'TJ', text: 'Tajikistan' },
//   { countryCode: 'TK', text: 'Tokelau' },
//   { countryCode: 'TL', text: 'Timor-Leste' },
//   { countryCode: 'TM', text: 'Turkmenistan' },
//   { countryCode: 'TN', text: 'Tunisia' },
//   { countryCode: 'TO', text: 'Tonga' },
//   { countryCode: 'TR', text: 'Turkey' },
//   { countryCode: 'TT', text: 'Trinidad and Tobago' },
//   { countryCode: 'TV', text: 'Tuvalu' },
//   { countryCode: 'TW', text: 'Taiwan, Province of China' },
//   { countryCode: 'TZ', text: 'Tanzania, United Republic of' },
//   { countryCode: 'UA', text: 'Ukraine' },
//   { countryCode: 'UG', text: 'Uganda' },
//   { countryCode: 'UM', text: 'United States Minor Outlying Islands' },
//   { countryCode: 'US', text: 'United States of America' },
//   { countryCode: 'UY', text: 'Uruguay' },
//   { countryCode: 'UZ', text: 'Uzbekistan' },
//   { countryCode: 'VA', text: 'Holy See' },
//   { countryCode: 'VC', text: 'Saint Vincent and the Grenadines' },
//   { countryCode: 'VE', text: 'Venezuela (Bolivarian Republic of)' },
//   { countryCode: 'VG', text: 'Virgin Islands (British)' },
//   { countryCode: 'VI', text: 'Virgin Islands (U.S.)' },
//   { countryCode: 'VN', text: 'Viet Nam' },
//   { countryCode: 'VU', text: 'Vanuatu' },
//   { countryCode: 'WF', text: 'Wallis and Futuna' },
//   { countryCode: 'WS', text: 'Samoa' },
//   { countryCode: 'YE', text: 'Yemen' },
//   { countryCode: 'YT', text: 'Mayotte' },
//   { countryCode: 'ZA', text: 'South Africa' },
//   { countryCode: 'ZM', text: 'Zambia' },
//   { countryCode: 'ZW', text: 'Zimbabwe' },
// ];
